"use client";
const o = (t) => {
  if (typeof t == "string")
    try {
      return JSON.parse(t);
    } catch {
      return t;
    }
  return t;
}, c = (
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  (...t) => (...n) => {
    for (const e of t)
      e?.(...n);
  }
), s = (t) => typeof t == "string";
function a(t) {
  return t.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/([A-Z])([A-Z][a-z])/g, "$1-$2").replace(/__/g, "__").toLowerCase();
}
const f = (t) => t ? "" : void 0;
function i(t) {
  const n = t.split(" "), e = n[0] ?? "", r = n.length > 1 ? n[n.length - 1] : "";
  return e && r ? `${e.charAt(0)}${r.charAt(0)}` : e.charAt(0);
}
function p(t, n) {
  return typeof t == "function" ? t(n) : t;
}
const g = (t) => typeof t.content == "string" ? t.content : t.content[0].text;
export {
  c as callAll,
  f as dataAttr,
  i as getInitials,
  g as getMessageContent,
  s as isString,
  p as maybeRender,
  o as parseIfJson,
  a as toKebabCase
};
